import axios from 'axios';
import { auth } from './firebase';

// Empty means same origin, which is what a deployed build wants: the server
// serves this bundle and the API, so a relative '/api' reaches the right host
// whatever it is called. Baking an absolute URL into the bundle would tie the
// build to one hostname and send every browser to that host regardless of where
// the page was actually loaded from.
//
// Local development sets this explicitly through docker-compose, because there
// the client and API are on different ports and same origin is not true. The
// fallback covers running the client outside the container, where nothing sets
// it at all; it is deliberately not reached when the value is set but empty.
const API_BASE_URL =
    process.env.REACT_APP_API_URL === undefined
        ? 'http://localhost:9000/api'
        : process.env.REACT_APP_API_URL || '/api';

// Create axios instance with default config
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add auth token
api.interceptors.request.use(
    async (config) => {
        const user = auth.currentUser;
        if (user) {
            const token = await user.getIdToken();
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            // Server responded with error status
            const { status, data } = error.response;

            if (status === 401) {
                // Token expired or invalid - could trigger logout here
                console.error('Authentication error:', data.message);
            } else if (status === 403) {
                console.error('Authorization error:', data.message);
            } else if (status >= 500) {
                console.error('Server error:', data.message);
            }
        } else if (error.request) {
            // Request made but no response received
            console.error('Network error: No response received');
        } else {
            // Error setting up request
            console.error('Request error:', error.message);
        }

        return Promise.reject(error);
    }
);

export default api;
